<template>

  <v-container fluid>
    <v-alert type="error" v-if="hasError" :value="!!error">{{this.error}}</v-alert>
    <v-flex>
      <v-text-field
        v-for="(val, key) in contactItem"
        :key="key"
        :label="key"
        :value="val"
        :readonly="key === 'id'"

        v-model="contactItem[key]"
      ></v-text-field>

      <v-btn @click.stop="dialogSave = true">Save changes</v-btn>
      <v-dialog
        v-model="dialogSave"
        max-width="290"
      >
        <v-card>
          <v-card-title class="headline">Confirm</v-card-title>
  
          <v-card-text>
            Are you sure you want to save your changes?
          </v-card-text>
  
          <v-card-actions>
            <v-spacer></v-spacer>
  
            <v-btn
              @click="dialogSave = false"
            >
              Cancel
            </v-btn>
  
            <v-btn
              @click="dialogSave = false; updateContact()"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-btn @click.stop="dialogDelete = true">Delete</v-btn>
      <v-dialog
        v-model="dialogDelete"
        max-width="290"
      >
        <v-card>
          <v-card-title class="headline">Confirm</v-card-title>
  
          <v-card-text>
            Are you sure you want to delete this contact?
          </v-card-text>
  
          <v-card-actions>
            <v-spacer></v-spacer>
  
            <v-btn
              @click="dialogDelete = false"
            >
              Cancel
            </v-btn>
  
            <v-btn
              @click="deleteContact()"
            >
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-flex>
  </v-container>
</template>

<script>
  import AWS from 'aws-sdk';

  export default {

    data() {
      return {
        dialogSave: false,
        dialogDelete: false,
        contactItem : {},
        error: "",
        hasError: false
      }
    },
    created() {
      this.dataService.getContact(this.$route.params.id).then(result => {
        console.log('getcontact ' , result.data);
        this.contactItem = result.data;
      });
    },

    methods: {
      updateContact() {
         this.hasError = false
          this.dataService.updateContact(this.$route.params.id, this.contactItem)
          .catch(err => {
            this.error = "Error while updating Contact"
            this.hasError = true
          })
          .then( () => {
            if(!this.hasError) {
              this.$router.push({ path: '/contacts' })
            }
          })          
      },

      deleteContact() {
        this.hasError = false
        this.dataService.deleteContact(this.contactItem.contactId)
        .catch(err => {
          console.log('ERROR')
          this.error = "Error while deleting: " + err.message
          this.hasError = true
        })
        .then( () => {
          if(!this.hasError) {
            this.$router.push({ path: '/contacts' })
          }
        })
      }
    }

  }

</script>



// WEBPACK FOOTER //
// GetContact.vue?9b613682